module.exports = {"421083001":"新堤街道","421083002":"滨湖街道","421083100":"螺山镇","421083101":"乌林镇","421083102":"龙口镇","421083103":"燕窝镇","421083104":"新滩镇","421083105":"峰口镇","421083106":"曹市镇","421083107":"府场镇","421083108":"戴家场镇","421083109":"瞿家湾镇","421083110":"沙口镇","421083111":"万全镇","421083112":"汊河镇","421083113":"黄家口镇","421083200":"老湾乡","421083450":"小港管理区","421083451":"大同湖管理区","421083452":"大沙湖管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421083.json
// module id = 1893
// module chunks = 0